/* eslint-disable react/no-array-index-key */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import WheelChoose from '@/components/WheelChoose';
import WheelChooseItem from '@/components/WheelChooseItem';

const Datepicker = ({
  validation,
  formatter,
  value,
  onChange,
  dateConstructor,
  monthNames,
  ...rest
}) => {
  const LocaleDate = dateConstructor;
  const defaultValue = [];
  if (value) {
    defaultValue.push(value);
  }
  const localDateRef = useRef(new LocaleDate(...defaultValue));


  function handleOnChange(newDate) {
    const prevDateEpoch = localDateRef.current.getTime();
    const newDateEpoch = newDate.getTime();
    if (prevDateEpoch !== newDateEpoch) {
      onChange(newDate);
    }
  }

  const updateLocalDate = (section, newValue) => {
    const methodIndex = ['day', 'month', 'year'].indexOf(section);
    const method = ['setDate', 'setMonth', 'setFullYear'][methodIndex];
    const newDate = new LocaleDate(localDateRef.current);
    if (typeof newValue === 'number') {
      newDate[method](newValue);
    }
    handleOnChange(newDate);
    localDateRef.current = newDate;
  };

  const getMonthName = (monthIndex) => (
    monthNames.length < monthIndex + 1 ? monthIndex + 1 : monthNames[monthIndex]
  );
  const getMonthLength = (monthIndex, year) => {
    const x = new LocaleDate();
    x.setFullYear(year);
    x.setMonth(monthIndex + 1);
    x.setDate(0);
    return x.getDate();
  };


  const renderSection = (section) => {
    if (section === 'year') {
      const currentYear = new LocaleDate().getFullYear();
      const startYear = currentYear - 90;
      return (
        <WheelChoose value={localDateRef.current.getFullYear()} onChange={(e) => updateLocalDate('year', e)}>
          {new Array(140).fill(null).map((_, index) => (
            <WheelChooseItem content={startYear + index} key={startYear + index}>
              {startYear + index}
            </WheelChooseItem>
          ))}
        </WheelChoose>
      );
    }
    if (section === 'month') {
      return (
        <WheelChoose value={localDateRef.current.getMonth()} onChange={(e) => updateLocalDate('month', e)}>
          {new Array(12).fill(null).map((_, index) => (
            <WheelChooseItem content={index} key={index}>
              {getMonthName(index)}
            </WheelChooseItem>
          ))}
        </WheelChoose>
      );
    }
    if (section === 'day') {
      const monthLength = getMonthLength(
        localDateRef.current.getMonth(),
        localDateRef.current.getFullYear(),
      );
      return (
        <WheelChoose value={localDateRef.current.getDate()} onChange={(e) => updateLocalDate('day', e)}>
          {new Array(monthLength || 30).fill(null).map((_, index) => (
            <WheelChooseItem content={index + 1} key={index + 1}>
              {index + 1}
            </WheelChooseItem>
          ))}
        </WheelChoose>
      );
    }
    return null;
  };

  return (
    <div
      {...rest}
    >
      <div _row="">
        { ['day', 'month', 'year'].map((section) => (
          <div _col_static="" _padding_x="md" key={section}>
            { renderSection(section) }
          </div>
        )) }
      </div>
    </div>
  );
};

Datepicker.propTypes = {
  /**
   * By default Datepicker will use Date constructor of native javascript.
   * But the good news is that you can pass
   * custom date constructors to render custom locales calendar.
   */
  dateConstructor: PropTypes.func,
  /**
   * List of month names. By default datepicker will render month numbers.
   */
  monthNames: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

Datepicker.defaultProps = {
  dateConstructor: Date,
  monthNames: [],
  value: undefined,
  onChange: () => {},
};

export default Datepicker;
